import React, { Component } from 'react';
import classnames from 'classnames';


type Props = {
  after: number | undefined,
  before: number | undefined,
  category: string | undefined,
  end: number | undefined,
  start: number | undefined,
};

type State = {
  value: string,
};

export default class ProgressBar extends Component<Props, State> {
  state = {
    value: '0%',
  };

  componentDidMount = () => {
    const { end, start } = this.props;
    // Initial value
    this.setState({ value: `${start}%` });

    setTimeout(() => {
      this.setState({ value: `${end}%` });
    }, 500);
  };

  render() {
    const {
      after,
      before,
      category,
      end,
      start,
    } = this.props;

    const { value } = this.state;

    // We need all of our optional properties to be defined
    if ([
      after,
      before,
      category,
      end,
      start,
    ].some(prop => prop === undefined)) {
      return null;
    }

    return (
      <div className="progress">
        <div className="progress__current">{before}</div>
        <div className="progress__bar">
          <div
            className={classnames(
              'progress-bar progress-bar--light-background',
              category === 'Menace' && 'progress-bar--menace',
            )}
          >
            <span
              className={classnames(
                'progress-bar__stripe',
                start !== end && 'progress-bar__stripe--has-transition',
                category === 'Menace' && 'progress-bar__stripe--menace',
              )}
              style={{ width: value }}
            />
          </div>
        </div>
        <div className="progress__current">{after}</div>
      </div>
    );
  }
}
